import React from "react";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import "./styles/global.css";
import { Routes } from "./routers";
import { ToastContainer } from "react-toastify";
import { BrowserRouter } from "react-router-dom";
import { AppProvider } from "./contexts";
import "./translations/i18n";
import "react-toastify/dist/ReactToastify.css";
import { QueryClientProvider } from "react-query";
import { ThemeProvider, createTheme } from "@mui/material";
import { theme } from "./material.theme";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { ptBR } from "date-fns/locale";
import Tooltip from "./components/Tooltip";
import { queryClient } from "./lib/queryClient";
import { PreEventD1Notifications } from "./components/PreEventD1Notifications";
function App() {
  return (
    <BrowserRouter>
      {/* `QueryClientProvider` must live ABOVE `AppProvider` because
          `BudgetProvider` (inside AppProvider) now runs a single
          `useQueries` to batch supplier-metadata lookups for the whole
          budget. With the previous order it would crash with
          "No QueryClient set, use QueryClientProvider to set one". */}
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={ptBR}
          >
            <ThemeProvider theme={theme}>
              <Tooltip />
              <Routes />
              <PreEventD1Notifications />
            </ThemeProvider>
          </LocalizationProvider>
          <ToastContainer stacked hideProgressBar />
        </AppProvider>
      </QueryClientProvider>
    </BrowserRouter>
  );
}

export default App;
